import { IState } from "../../../../../common/state/IState";

export const screenLockerSelector = (s: IState) => s?.userManagement?.screenLocker;
